export default "__VITE_ASSET__5bff8f06__"